<template>
  <div id="app">
    <keep-alive include="InformationCenter">
    <router-view />
    </keep-alive>
      <div style="width:566px;height:185px;position: fixed;top:70%;right:20px">
        <div class="phoneupload">
        <div style="padding-top:17px;text-align: center;width:100%">
          <img class="img1" src="../static/phoneactive.png" alt="">
          <img class="img2" src="../static/phone.png" alt="">
        </div>
        <div class="phonename">
          <p>手机APP下载</p>
        </div>
      </div>
      <div class="uploadImg">
        <div class="sanjiao">&#9660;</div>
        <div style="width:134px">
          <div class="imgwrap">
            <img src="../static/shixuncode.png" alt="">
          </div>
          <p class="imgp" style="text-align: center">实训APP</p>
        </div>
        <div style="width:134px">
          <div class="imgwrap">
            <img src="../static/wangchuangcode.png" alt="">
          </div>
          <p class="imgp" style="text-align: center">网创APP</p>
        </div>
        <div style="width:134px">
          <div class="imgwrap">
            <img src="../static/QRCode.png" alt="">
          </div>
          <p class="imgp" style="text-align: center">慕课APP</p>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
html,body,#app {
	height:100%;
}
.phoneupload {
  position: absolute;
  width: 100px;
  height: 100px;
  background: #FFFFFF;
  border-radius: 10px;
  right: 0px;
  top: 43px;
  box-sizing: border-box;
  border: 1px solid #1C43BD;
  cursor: pointer;
  
}
.phoneupload img {
  width: 23px;
  height: 41px;
  margin: 0 auto;
}

.phoneupload .img2 {
  display: none;
}
.phoneupload .phonename {
  padding-top: 11px;
  text-align: center;
  color: #1555E7;
  font-size: 14px;
  font-family: PingFang SC;
}
.phoneupload .img1 {
  display: block;
}
.phoneupload:hover {
  background: #1555E7;
  border-color: #1555E7;
}
.phoneupload:hover .img1 {
  display: none;
}
.phoneupload:hover .img2 {
  display: block;
}
.phoneupload:hover .phonename {
  color: #FFFFFF;
}
.phoneupload:hover ~ .uploadImg {
  opacity: 1;
}
.uploadImg {
  opacity: 0;
  width: 458px;
  height: 187px;
  background: #FFFFFF;
  box-shadow: 0px 0px 38px 0px rgba(56, 56, 56, 0.2);
  border-radius: 6px;
  padding: 14px 14px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 0px;
  right: 121px;
  z-index: 999;
}
.sanjiao {
  position: absolute;
  right: -9px;
  top: 88px;
  transform: rotate(-90deg);
  color: #fff;
}
.imgp {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1555E7;
  line-height: 36px;
}
.imgwrap {
  width: 130px;
  height: 130px;
  background-image: url('../static/bgboeder.png');
  background-size: 130px;
  
}
.imgwrap img {
  width: 120px;
  height: 120px;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue